import React, { FC, useMemo } from 'react';
import clsx from 'clsx';
import styles from './category5.module.scss';

export interface WasteDiversionRateCardProps {
  rate: number | null | undefined;
}

const WasteDiversionRateCard: FC<WasteDiversionRateCardProps> = ({ rate }) => {
  const { tone, displayText } = useMemo(() => {
    if (rate == null) {
      return { tone: 'neutral' as const, displayText: '—' };
    }
    const n = Number(rate);
    if (!Number.isFinite(n)) {
      return { tone: 'neutral' as const, displayText: '—' };
    }
    const display = `${n.toFixed(1)}%`;
    if (n >= 90) {
      return { tone: 'success' as const, displayText: display };
    }
    return { tone: 'warning' as const, displayText: display };
  }, [rate]);

  return (
    <div
      className={clsx(styles.diversionRateCard, {
        [styles.diversionRateCardSuccess]: tone === 'success',
        [styles.diversionRateCardWarning]: tone === 'warning',
        [styles.diversionRateCardNeutral]: tone === 'neutral',
      })}
      data-testid="waste-diversion-rate-card">
      <div className={styles.diversionRateCardLabel}>Waste diversion rate</div>
      <div className={styles.diversionRateCardValue}>{displayText}</div>
    </div>
  );
};

export default WasteDiversionRateCard;
